import { FC } from "react";

const TermsOfUse: FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Terms of Use</h1>
      <p>
        Welcome to WillTheyConvert! These terms of use outline the rules and
        regulations for the use of our website and services.
      </p>
      <p>
        By accessing this website, we assume you accept these terms of use. Do
        not continue to use WillTheyConvert if you do not agree to take all of
        the terms of use stated on this page.
      </p>
    </div>
  );
};

export default TermsOfUse;
